/** @file The slot key of one image cell: `<drawable>/<entry index>/<tile index>` (ruling R1). */

/** Key of the slot for tile `tile` of entry `entry` (its index in `facets`) of drawable `drawable`. */
export function slotKey(drawable: string, entry: number, tile: number): string {
  return `${drawable}/${entry}/${tile}`;
}
